import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

// Two interlocking L-brackets. They overlap where they cross, so this path
// keeps the default nonzero fill rule: evenodd would cut holes at the
// crossings.
export const Crop = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="crop icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M4.5 2.5A1.5 1.5 0 0 1 7.5 2.5V16.5H21.5A1.5 1.5 0 0 1 21.5 19.5H6A1.5 1.5 0 0 1 4.5 18V2.5ZM2.5 4.5H18A1.5 1.5 0 0 1 19.5 6V21.5A1.5 1.5 0 0 1 16.5 21.5V7.5H2.5A1.5 1.5 0 0 1 2.5 4.5Z"
    />
  </svg>
)
